import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum AutoOnboardCheckoutOptimizationStatus {
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  NOT_FOUND = "NOT_FOUND",
}

export const getAutoOnboardCheckoutOptimizationStatus = {
  name: "getAutoOnboardCheckoutOptimizationStatus" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    status: createEnum(AutoOnboardCheckoutOptimizationStatus),
  }),
};
